import client from "../api-client"

export default class BillingDataAPI {
  static query = (params = "") => {
    return client(`billing-data?${params}`)
  }
}
